import * as React from "react";
import { Helmet } from "react-helmet-async";

const PoiListError = () => {

    const handleBack = (e) => {
        history.back();
        e.stopPropagation();
    }

    return (
        <div className="poi-error">
            <h3>We&rsquo;re Sorry...</h3>
            <p>
                We could not find a halfway point between the addresses you provided.
                Make sure your search is spelled correctly. Try adding a city, state, or zip code.
            </p>
            <p>
                If you feel you have reached this page in error, please feel free to <a href="/contact">contact us</a>.
            </p>
            <p>&nbsp;</p>
            <p>
                <span className="link-primary" onClick={handleBack}><i className="material-icons">arrow_back</i> Go back</span>
            </p>
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
        </div>
    );
}


export default PoiListError;


